if (!window.Eurus.loadedScript.has('share-cart.js')) {
  window.Eurus.loadedScript.add('share-cart.js');
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xCartShare', {
        openShareCart: false,
        cartShareUrl: "",
        shared: false,
        copySuccess: false,

        /**
         * Builds the shareable URL by encoding each cart item's variant ID,
         * quantity, and bundle-related properties into the query string.
         *
         * Bundle properties encoded:
         *   _main_bundle_id  — marks the primary item in a bundle group
         *   _bundle_id       — marks a sub-item (lens, GWP, power, etc.)
         *   _high_cyl_fee_id — links a High CYL fee item to its bundle group
         *   _high_cyl_fees_product — flags the item as a High CYL fee product
         *   type             — e.g. "prescription" used by checkout scripts
         */
        generateUrl() {
          fetch(Shopify.routes.root + 'cart.js', {
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
          })
          .then(response => response.json())
          .then(response => {
            const items = window.sortBundleCartItemsForAdd
              ? window.sortBundleCartItemsForAdd(response.items.slice())
              : response.items.slice();

            const BUNDLE_PROPS = [
              '_main_bundle_id',
              '_bundle_id',
              '_high_cyl_fee_id',
              '_high_cyl_fees_product',
              'type'
            ];

            const cartParams = items.map(item => {
              let param = `id:${item.variant_id},q:${item.quantity}`;

              // Collect relevant bundle properties for this item
              const bundleData = {};
              BUNDLE_PROPS.forEach(key => {
                if (item.properties && item.properties[key] != null && item.properties[key] !== '') {
                  bundleData[key] = item.properties[key];
                }
              });

              // Only append bundle data if there is something to encode
              if (Object.keys(bundleData).length > 0) {
                try {
                  // Base64-encode the JSON so it survives URL encoding cleanly
                  const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(bundleData))));
                  param += `,bp:${encoded}`;
                } catch (e) {
                  // Encoding failed — skip bundle properties for this item
                  console.warn('[share-cart] Failed to encode bundle properties for item', item.variant_id, e);
                }
              }

              return param;
            }).join('&') + '&share_cart:true';

            this.cartShareUrl = `${window.location.origin}?${cartParams}`;
          });
        },

        copyURL() {
          const cartShareInput = document.getElementById(`x-share-cart-field`);
          if (cartShareInput) {
            navigator.clipboard.writeText(cartShareInput.value).then(
              () => {
                this.copySuccess = true;
                setTimeout(() => {
                  this.copySuccess = false;
                }, 2000);
              },
              () => {
                alert('Copy fail');
              }
            );
          }
        },

        /**
         * Parses the shared cart URL and re-adds all items — including bundle
         * sub-items and High CYL fee items — with their properties restored.
         *
         * Bundle ID remapping:
         *   The original bundle IDs are timestamps from the sharer's session.
         *   We generate fresh IDs here, but maintain the same grouping by
         *   mapping each original ID → a new ID before adding to cart.
         */
        handleShareCart() {
          const queryString = window.location.search;
          if (!queryString.includes("share_cart:true")) return;

          // Map: originalBundleId → freshBundleId
          const bundleIdMap = {};

          const getOrCreateBundleId = (originalId) => {
            if (!bundleIdMap[originalId]) {
              bundleIdMap[originalId] = Date.now() + Math.floor(Math.random() * 10000);
            }
            return bundleIdMap[originalId];
          };

          const items = queryString
            .substring(1)
            .split('&')
            .reduce((listItem, param) => {
              if (param.startsWith('id:')) {
                // param format: "id:VARIANT_ID,q:QTY[,bp:BASE64]"
                const parts = param.split(',');
                const id = parseInt(parts[0].slice(3));
                const quantity = parseInt(parts[1].slice(2));

                // Base64-encoded bundle properties part (optional)
                const bpPart = parts.find(p => p.startsWith('bp:'));
                let properties = {};

                if (bpPart) {
                  try {
                    const bundleData = JSON.parse(
                      decodeURIComponent(escape(atob(bpPart.slice(3))))
                    );

                    // Remap bundle IDs to fresh ones, preserving grouping
                    if (bundleData._main_bundle_id) {
                      bundleData._main_bundle_id = getOrCreateBundleId(bundleData._main_bundle_id);
                    }
                    if (bundleData._bundle_id) {
                      bundleData._bundle_id = getOrCreateBundleId(bundleData._bundle_id);
                    }
                    if (bundleData._high_cyl_fee_id) {
                      bundleData._high_cyl_fee_id = getOrCreateBundleId(bundleData._high_cyl_fee_id);
                    }

                    properties = bundleData;
                  } catch (e) {
                    console.warn('[share-cart] Failed to decode bundle properties for item', id, e);
                  }
                }

                listItem.push({ id, quantity, properties });
              }
              return listItem;
            }, []);

          if (items.length > 0) {
            this.addCartItems(items);
          }
        },

        addCartItems(items) {
          const formData = {
            'items': items,
            'sections': Alpine.store('xCartHelper').getSectionsToRender().map((s) => s.id)
          };

          fetch(Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify(formData)
          }).then(response => response.json())
            .then(response => {
              Alpine.store('xCartHelper').reRenderSections(response.sections);
              Alpine.store('xMiniCart').openCart();
              Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
              document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
              this.shared = true;
            })
            .catch(error => {
              console.error(error);
            });
        }
      });
    });
  });
}